<template xmlns="http://www.w3.org/1999/html">
    <div>
        <div class="simple-form flex col-4 label" v-if="flag">
            <div class="form-group center">
                <div class="form-label">
                    <label>供应商名称</label>
                </div>
                <div class="form-value">
                    <span>{{ contranct.sndPartyName }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>系统合同编号</label>
                </div>
                <div class="form-value">
                    <span>{{ contranct.no }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>支付方式</label>
                </div>
                <div class="form-value">
                    <span>{{ contranct.payWayName }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>合同状态</label>
                </div>
                <div class="form-value">
                    <span v-if="contranct.confirmed && !contranct.fullfilled" class="">履约中</span>
                    <span v-if="contranct.fullfilled && !contranct.checked" class="">履约完成</span>
                    <span v-if="contranct.checked" class="">已验收</span>
                </div>
            </div>
        </div>
        <div class="simple-row" v-if="flag">
            <div class="right">
                <button class="swb-btn swb-btn-small swb-btn-primary" @click="prevContract">返回</button>
            </div>
        </div>
        <swb-query-sort-area name="query_model_ctrl" ref="query_model_ctrl" :confKey="confKey" :configAuto="true" :onConfigReady="onConfigReady" :queryHandler="queryHandler"></swb-query-sort-area>

        <swb-result-table name="result_table" :btnColBaseCount="2" :btnColMoreTitle="'更多操作'" ref="result_table" :confKey="confKey" :configAuto="true" :needPager="needPager" :rowNoShow="rowNoShow" :rowNoFixed="rowNoFixed"
                          :btnColName="btnColName" :btnColTitle="btnColTitle" :btnColWidth="btnColWidth" :btnColFixed="btnColFixed" :height="theTableHeight" :pageNoChangeHandler="handlePageChange"
                          :rowDblClickHandler="rowDblClickHandler"></swb-result-table>
    </div>
</template>

<script>
import { Utils, $ } from '../../app.base'
import { Vue, MsgBox, Routes, DomSizeWatcher } from '../../app.vues'
import { openPageRouteUrl, getDefaultPageSizes } from '../../app.conf';
import { checkUserActionPerm } from '../index'
import { showPayVoucherListForSelectDlg } from '../payment/ActRecDlg'
import { openGoodsOrderInfoForPdf, openOnlineSignForm, openOnlineSignFormView } from './dialog'
import {showRouteLayer} from "../ctrl/RouteLayer";
//
import contractApi from '../../api/contract'
import goodsOrderApi from '../../api/goodsOrder'
import esignBizFormApi from '../../api/esignBizForm';

import SwbShowGoodsOrder from './ShowGoodsOrder';

Routes.add(SwbShowGoodsOrder);
import SwbComplaintSave from '../custsvc/ComplaintSave';

Routes.add(SwbComplaintSave);
import SwbTradeVoucherList from '../tradeVoucher/TradeVoucherList';

Routes.add(SwbTradeVoucherList);
import SwbPayVoucherList from '../payment/PayVoucherList';

Routes.add(SwbPayVoucherList);
import SwbDeviceRequireVoucherManager from '../retailer/DeviceRequireVoucherManager';

Routes.add(SwbDeviceRequireVoucherManager);
import SwbPurchReceiptList from '../receipt/PurchReceiptList';

Routes.add(SwbPurchReceiptList);

import SwbGoodsOrderSignConfirmedInfo from './GoodsOrderSignConfirmedInfo';

Vue.regist(SwbGoodsOrderSignConfirmedInfo);

import SwbQuerySortArea from '../query/QuerySortArea';

Vue.regist(SwbQuerySortArea);

import GoodsOrderImgList from './GoodsOrderImgList';

Vue.regist(GoodsOrderImgList);

let searchConfigData = {
    'queryFields': [{
        'type': 'Text',
        'label': '订单号',
        'code': 'no',
        'basic': true
    }, {
        'type': 'Text',
        'label': '交易单号',
        'code': 'tradeNo',
        'basic': true
    }, {
        'type': 'Text',
        'label': '请购单号',
        'code': 'cgVoucherNo',
        'basic': true
    }, {
        'type': 'Select',
        'label': '采购模式',
        'valueType': 'Boolean',
        'code': 'centBuyFlag',
        'dataList': [{
            'value': null,
            'label': '- 全部 -'
        }, {
            'value': 'true',
            'label': '集采'
        }, {
            'value': 'false',
            'label': '自采'
        }],
        'basic': true
    }, {
        'type': 'Select',
        'label': '配货方式',
        'valueType': 'Boolean',
        'code': 'manualAllocFlag',
        'dataList': [{
            'value': null,
            'label': '- 全部 -'
        }, {
            'value': 'true',
            'label': '手工配货'
        }, {
            'value': 'false',
            'label': '自动配货'
        }],
        'basic': true
    }, {
        'type': 'Date2',
        'valueType': 'String',
        'label': '时间筛选',
        'code': 'createTime',
        'basic': false
    }, {
        'type': 'Text',
        'label': '供方名称',
        'code': 'sellerName',
        'valueType': 'String'
    }, {
        'type': 'Text',
        'label': '供方标识',
        'code': 'sellerInnerCode',
        'valueType': 'String'
    }, {
        'type': 'Num2',
        'valueType': 'Float',
        'label': '订单金额',
        'code': 'totalAmount'
    }, {
        'type': 'Select',
        'label': '交易状态',
        'code': 'state',
        'dataList': [{
            'value': null,
            'label': '- 全部 -'
        }, {
            'value': '已提交',
            'label': '已提交'
        }, {
            'value': '待交付',
            'label': '待交付'
        }, {
            'value': '交付中',
            'label': '交付中'
        }, {
            'value': '交付完成',
            'label': '交付完成'
        }, {
            'value': '已取消',
            'label': '已取消'
        }, {
            'value': '已关闭',
            'label': '已关闭'
        }]
    }, {
        'type': 'Select',
        'label': '交付状态',
        'code': 'shipAndRecvState',
        'dataList': [{
            'value': null,
            'label': '- 全部 -'
        }, {
            'value': 'toShip',
            'label': '未发货'
        }, {
            'value': 'partShip',
            'label': '已部分发货'
        }, {
            'value': 'partRecv',
            'label': '已部分收货'
        }, {
            'value': 'allShip',
            'label': '已全部发货'
        }, {
            'value': 'allRecv',
            'label': '已全部收货'
        }]
    }, {
        'type': 'Text',
        'label': '采购业务单元',
        'code': 'buyerBizUnitName',
        'valueType': 'String'
    }],
    'sortFields': [{
        'label': '创建时间',
        'code': 'createTime',
        'order': 'desc',
        'enabled': true
    }, {
        'order': 'asc',
        'label': '订单号',
        'code': 'no',
        'enabled': true
    }]
};

function resetSearchConfigData(no, queryConfig) {
    let searchConfigData = queryConfig || {};
    if(searchConfigData != null) {
        let searchConfigMap = searchConfigData.queryFields.toMap('code');
        let item = searchConfigMap['no'];
        item.value = no;
    }
}

export default {
    name: 'swb-goods-order-list',
    path: '/goods/order/list',
    avlActions: 'view_detail|cancel|initiate_complaint',
    avlActionNames: '详单详情、取消、发起投述',
    avlScopes: 'retailer',
    desc: '商品订单列表',
    data: function () {
        return {
            confKey: 'swb-goods-order-list',
            theTableHeight: 300,
            queryOnLoad: true,
            //
            needPager: true, //是否需要分页（默认：true）
            multiSelect: true, //是否多选（默认：false）
            multiPageSelect: true, //是否要多页/跨页选择（默认：false）
            rowKeyPropName: 'id', //记录数据关键标识列名（多页/跨页选择必须，默认: id）
            rowNoShow: false, //是否显示行号（默认：true）
            rowNoFixed: true, //行号列是否固定（默认：false）
            btnColName: 'actions',//操作列名称（如果不设置就不显示操作列）
            btnColTitle: '操作',//操作列标题（默认：'操作'）
            btnColWidth: 260,//操作列宽度（默认：100）
            btnColFixed: true, //操作列是否固定
            //
            pageNumber: 1,
            totalCount: 0,
            pageSize: null,
            pageSizes: getDefaultPageSizes(),
            //排序、搜索
            queryConfig: null,
            queryKey: null,
            queryModel: {
                filterItems: {},
                sortItemList: [],
                sortItems: {},
            },
            //
            contranct: {
                closed: false
            },
            no: null,
            goodsOrderList: [],
            contractId: null,
            flag: false,
            offlinePayWay: {},
            unionpayPayWay: {},
            recvStateInfo: {},
            shipStateInfo: {},
            tradeNo: null,
            cgVoucherNo: null,
            tradeType: null,
            createOrderStart: null,
            createOrderEnd: null,
            generalVoucherType: {},
            contractVoucherType: {},
            cgVoucherId: null,
            path: null,
            signStatusMap: getEnumMap('goodsOrderEsignState', 'value2text')
        }
    },
    watch: {
        '$route': 'fetchData'
    },
    created: function () {
        this.path = Vue.$getClassInfo(this).path;
        // --------------------查询--------------------------------
        this.fetchData();
    },

    mounted() {
        let self = this;
        //注册domSizeWatcher
        let thisEl = $(this.$el);
        $(this.$el).addClass('overflow-hidden');
        //
        let domSizeWatcher = this.domSizeWatcher = new DomSizeWatcher(Vue.$getClassInfo(this).name);
        domSizeWatcher.setBaseEl(thisEl);
        domSizeWatcher.setMainEl(thisEl.find('[name="result_table"]'), function (width, height, theEl) {
            //根据新主元素的内容大小，调整表格高度
            self.theTableHeight = height;

        });
        //domSizeWatcher.setHrEls();
        domSizeWatcher.setVtEls(thisEl.find('.simple-form, .simple-row, [name="query_model_ctrl"]'));
        domSizeWatcher.start(500);
        //
        this.initResultTable();
    },
    destroyed() {
        //释放domSizeWatcher
        let domSizeWatcher = this.domSizeWatcher;
        if(domSizeWatcher != null) {
            domSizeWatcher.clear();
            this.domSizeWatcher = null;
        }
    },

    methods: {
        initResultTable() {
            let self = this;
            let query_model_ctrl = this.$refs['query_model_ctrl'];
            let resultTable = this.$refs['result_table'];
            //关联[列配置对象]到结果表格（结果表格可以实时利用最新的列配置，同时结果表格列宽也会反向同步到[列配置对象]中去）
            resultTable.setQrySortRef(query_model_ctrl);
            resultTable.initMeta(/* confColList, */ /* 单元格html渲染函数 */{

                'tradeNo': function (row, colName, colValue, rowIndex, colConf) {
                    if(row.tradeNo != null) {
                        return '<span><a class="table-cell-link" >' + row.tradeNo + '</a></span>';
                    }
                },
                'cgVoucherInnerNo': function (row, colName, colValue, rowIndex, colConf) {
                    if(row.cgVoucherId != -1) {
                        let cgVoucherInnerNo = Utils.isNoB(row.cgVoucherInnerNo) ? row.cgVoucherNo : row.cgVoucherInnerNo;
                        return '<span><a class="table-cell-link" >' + cgVoucherInnerNo + '</a></span>';
                    }
                },
                'trackPhaseName': function (row, colName, colValue, rowIndex, colConf) {
                    if(self.flag && row.trackPhaseName != null) {
                        return '<span>' + row.trackPhaseName + '</span>';
                    }
                },
                'shipState': function (row, colName, colValue, rowIndex, colConf) {
                    if(row.shipState == 0) {
                        return '<span>未发货</span>';
                    } else if(row.shipState == 1 && row.recvState == 0) {
                        return '<span>已部分发货</span>';
                    } else if(row.shipState == 1 && row.recvState == 1) {
                        return '<span>已部分收货</span>';
                    } else if(row.shipState == 1 && row.recvState == 2) {
                        return '<span>已全部收货</span>';
                    } else if(row.shipState == 2 && row.recvState == 0) {
                        return '<span>已全部发货</span>';
                    } else if(row.shipState == 2 && row.recvState == 1) {
                        return '<span>已部分收货</span>';
                    } else if(row.shipState == 2 && row.recvState == 2) {
                        return '<span>已全部收货</span>';
                    }
                },
                'cancelled': function (row, colName, colValue, rowIndex, colConf) {
                    if(row.cancelled) {
                        return '<span>已取消</span>';
                    } else if(!Utils.isNoB(row.state)) {
                        return '<span>' + row.state + '</span>';
                    } else {
                        // 再状态机执行完毕之前默认未【已提交】状态
                        return '<span>已提交</span>';
                    }
                },
                'signStatus': function (row, colName, colValue, rowIndex, colConf) {
                    return '<span>' + self.signStatusMap[row.signStatus] + '</span>';
                },
                'actions': function (row, colName, colValue, rowIndex, colConf) {
                    let btnList = [];

                    if(self.checkActionPerm('view_pay_detail' && self.contractId == null)) {
                        btnList.push({
                            name: 'view_pay_detail',
                            text: '付款明细'
                        })
                    }

                    if(self.checkActionPerm('view_detail')) {
                        btnList.push({
                            name: 'view_detail',
                            text: '订单详情'
                        })
                    }

                    if(self.checkActionPerm('cancel') && !row.cancelled && row.shipState == 0 && !self.contranct.closed) {
                        btnList.push({
                            name: 'cancel',
                            text: '取消'
                        })
                    }

                    if(self.checkActionPerm('initiate_complaint') && !self.contranct.closed) {
                        btnList.push({
                            name: 'initiate_complaint',
                            text: '发起投诉'
                        })
                    }
                    // if(self.checkActionPerm('pre_pay') && !row.invalid && row.contractId == null) {
                    //     btnList.push({
                    //         name: 'pre_pay',
                    //         text: '预付'
                    //     })
                    // }
                    if(self.checkActionPerm('download_pdf') && !row.cancelled) {
                        btnList.push({
                            name: 'download_pdf',
                            text: '下载PDF'
                        })
                    }
                    if(self.checkActionPerm('sign_confirmed') && !row.invalid && !row.buyerSignConfirmed && !row.signConfirmNeeded) {
                        btnList.push({
                            name: 'confirmed',
                            text: '确认'
                        })
                    }
                    if(self.checkActionPerm('sign_confirmed') && !row.invalid && !row.signConfirmNeeded) {
                        btnList.push({
                            name: 'sign',
                            text: '查看签名文件'
                        })
                    }
                    if(self.checkActionPerm('sign_confirmedX') && !row.invalid && !row.buyerSignConfirmed && row.signConfirmNeeded && !row.onlineSignFlag) {
                        btnList.push({
                            name: 'sign_confirmedX',
                            text: '签署确认'
                        })
                    }
                    if(self.checkActionPerm('sign_confirmedX') && !row.invalid && row.buyerSignConfirmed && row.signConfirmNeeded && !row.onlineSignFlag) {
                        btnList.push({
                            name: 'sign_file',
                            text: '查看签署文件'
                        })
                    }
                    if(self.checkActionPerm('set_orig_file') && row.signConfirmNeeded) {
                        btnList.push({
                            name: 'set_orig_file',
                            text: '下载待签署文件'
                        })
                    }
                    if(self.checkActionPerm('send_sign_form') && row.signConfirmNeeded && row.onlineSignFlag && row.signFlowStatus == 0) {   // 签署单：未发起
                        btnList.push({
                            name: 'send_sign_form',
                            text: '发起签署'
                        })
                    }
                    if(self.checkActionPerm('reSend_sign_form') && row.signConfirmNeeded && row.onlineSignFlag //
                        && (row.signFlowStatus == 3 || row.signFlowStatus == 5 || row.signFlowStatus == 7)) {   // 签署单：已撤销、已过期、已拒签
                        btnList.push({
                            name: 'reSend_sign_form',
                            text: '重新发起签署'
                        })
                    }
                    if(self.checkActionPerm('show_sign_form') && row.signConfirmNeeded && row.onlineSignFlag) {
                        btnList.push({
                            name: 'show_sign_form',
                            text: '查看签署单'
                        })
                    }
                    if(self.checkActionPerm('ship_aborted') && row.recvState == 1 && !row.shipAborted) {
                        btnList.push({
                            name: 'ship_aborted',
                            text: '无需继续发货'
                        })
                    }
                    btnList.push({
                        name: 'acceptance_sheet',
                        text: '验收单'
                    });
                    btnList.push({
                        name: 'file_comn',
                        text: '附件管理'
                    });
                    return btnList
                },
            }, /* 单元格按钮点击处理函数 */ {
                'tradeNo': function (row, colName, colValue, rowIndex, btnName) {
                    self.toTradeVoucherList(row.tradeNo, row.contractNo)
                },
                'cgVoucherInnerNo': function (row, colName, colValue, rowIndex, btnName) {
                    if(row.cgVoucherId != -1) {
                        self.toCgVoucherList(row.cgVoucherNo, row.cgStuffFlag)
                    }
                },
                'actions': function (row, colName, colValue, rowIndex, btnName, event) {
                    if(btnName == 'view_pay_detail') { // 付款明细
                        self.resetpay(row);
                    } else if(btnName == 'view_detail') { // 订单详情
                        self.toGoodsOrderInfo(row.id, row.manualAllocFlag);
                    } else if(btnName == 'cancel') { // 取消
                        self.doCancelGoodsOrderById(row.id)
                    } else if(btnName == 'initiate_complaint') { // 发起投诉
                        self.complaintSave(row.id);
                    } else if(btnName == 'pre_pay') { // 预付
                        self.doPayPre(row);
                    } else if(btnName == 'download_pdf') { // 下载PDF
                        self.downloadPdf(row.id);
                    } else if(btnName == 'confirmed') { // 确认
                        self.doSignConfirmed(row, false, false);
                    } else if(btnName == 'sign_confirmedX') { // 签署确认
                        self.doSignConfirmed(row, false, true);
                    } else if(btnName == 'sign') { // 查看签名文件
                        self.doSignConfirmed(row, true, false);
                    } else if(btnName == 'sign_file') { // 查看签署文件
                        self.doSignConfirmed(row, true, true);
                    } else if(btnName == 'set_orig_file') { // 下载待签署文件
                        self.setOrigFile(row.id)
                    } else if(btnName == 'send_sign_form') { // 签署单
                        self.onlineSignForm(row.onlineSignFormId)
                    } else if(btnName == 'reSend_sign_form') {
                        self.onlineSignForm(row.onlineSignFormId)
                    } else if(btnName == 'show_sign_form') {
                        self.showOnlineSignForm(row.onlineSignFormId)
                    } else if(btnName == 'acceptance_sheet') { // 验收单
                        self.toViewPurchReceipt(row);
                    } else if(btnName == 'ship_aborted') {
                        self.doShipAborted(row);
                    } else if(btnName == 'file_comn') {
                        self.fileComn(row);
                    }
                }
            });
        },
        renderTable(rows, pagination) {
            let resultTable = this.$refs.result_table;
            let tableData = {
                rows: rows,
                pagination: pagination
            };
            resultTable.render(tableData);
        },
        // 单元格点击事件
        rowDblClickHandler: function (row) {
            if(!this.multiSelect) {
                console.log('----- 双击数据行 ----');
                console.log(row);
            }
        },
        //
        queryHandler(queryModel) {
            this.queryModel = queryModel;
            //
            this.pageNumber = 1;
            this.toGetGoodsOrderList();
        },
        // 检查资源具体操作权限（可选的是否为指定的岗位id）
        checkActionPerm: function (action, targetPostId) {
            return checkUserActionPerm(Vue.$getClassInfo(this).path, action, targetPostId);
        },
        fetchData: function () {
            //
            this.pageSize = this.pageSizes.first();
            //
            let routeQuery = this.$getRouteQuery();
            this.no = routeQuery.no || null;
            this.cgVoucherId = routeQuery.cgVoucherId || null;
            //----------------------搜索排序----------------------------
            //查询排序配置信息
            let queryConfig = Utils.merge({}, searchConfigData);
            //查询回调函数调用上下文对象
            //queryConfig.queryContext = this;
            //
            if(!Utils.isNoB(this.no)) {
                resetSearchConfigData(this.no, queryConfig);
            }
            this.queryModel.filterItems.no = this.no;
            //
            this.queryConfig = queryConfig;
            //
            let contractId = routeQuery.contractId || null;
            this.contractId = contractId;
            if(contractId != null) {
                //
                this.getContractById(contractId);
                this.flag = true;
            } else {
                this.flag = false;
            }

            this.offlinePayWay = getEnumInfoWith('payWay', 'name', 'Offline');
            this.unionpayPayWay = getEnumInfoWith('payWay', 'name', 'Unionpay');
            this.recvStateInfo = getEnumMap('recvState', 'value2text');
            this.shipStateInfo = getEnumMap('shipState', 'value2text');

            this.generalVoucherType = getEnumInfoWith('tradeVoucherType', 'name', 'GeneralVoucher');
            this.contractVoucherType = getEnumInfoWith('tradeVoucherType', 'name', 'ContractVoucher');

            this.toGetGoodsOrderList();
        },
        onConfigReady() {
            //
            let no = this.no;
            if(no != null) {
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                let data = {value: no};
                let fieldInfo = {};
                fieldInfo['no'] = data;
                query_model_ctrl.updateFields(fieldInfo);
            }
            // 签署状态 signStatus
            let goodsOrderEsignStateList = getEnumList('goodsOrderEsignState') || [];
            let dataList = [{'value': null, 'label': '- 全部 -'}];
            if(goodsOrderEsignStateList.length > 0) {
                goodsOrderEsignStateList.forEach(function (item) {
                    let dataInfo = {};
                    dataInfo.value = item.value;
                    dataInfo.label = item.text;
                    dataList.push(dataInfo);
                });
                this.updateQueryModelField('signStatus', dataList);
            }
        },
        updateQueryModelField: function (itemCode, dataList = []) {
            if(itemCode != null) {
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                let data = {dataList: dataList};
                let fieldInfo = {};
                fieldInfo[itemCode] = data;
                query_model_ctrl.updateFields(fieldInfo);
            }
        },
        prevContract: function () {
            this.$getRouter().back(-1);
        },
        handleSizeChange: function (val) {
            let curStartIndex = (this.pageNumber - 1) * this.pageSize;
            this.pageSize = val;
            let newPageNumber = Math.max(1, Math.ceil(curStartIndex / this.pageSize));
            this.handlePageChange(newPageNumber);
        },
        handlePageChange: function (val) {
            this.pageNumber = val;
            this.toGetGoodsOrderList();
        },
        getContractById: function (contractId) {
            let self = this;
            let postData = {};
            postData.id = contractId;
            //
            contractApi.getContractInfo(postData, function (result) {
                if(result.type == 'info') {
                    let contranct = result.data;
                    let offlinePayWay = self.offlinePayWay;
                    let unionpayPayWay = self.unionpayPayWay;
                    if(offlinePayWay.value == contranct.payWay) {
                        contranct.payWayName = offlinePayWay.text
                    } else {
                        contranct.payWayName = unionpayPayWay.text
                    }
                    self.contranct = contranct;
                }
            });
        },
        toGetGoodsOrderList: function () {
            let self = this;
            let contractId = self.contractId || null;
            let postData = {};
            postData.pagination = {
                pageSize: self.pageSize,
                pageNumber: self.pageNumber,
            };

            let queryModel = self.queryModel;
            let filterItems = Utils.merge({}, queryModel.filterItems);
            let sortItemList = Utils.merge([], queryModel.sortItemList);
            let sortItems = Utils.merge({}, queryModel.sortItems);
            //
            let shipAndRecvState = filterItems.shipAndRecvState;
            if(!Utils.isNoB(shipAndRecvState)) {
                if(shipAndRecvState == 'toShip') {
                    filterItems.shipState = 0;
                } else if(shipAndRecvState == 'partShip') {
                    filterItems.shipState = 1;
                    filterItems.recvState = 0;
                } else if(shipAndRecvState == 'partRecv') {
                    // filterItems.shipState != 0;
                    filterItems.recvState = 1;
                } else if(shipAndRecvState == 'allRecv') {
                    // filterItems.shipState = 1;
                    filterItems.recvState = 2;
                } else if(shipAndRecvState == 'allShip') {
                    filterItems.shipState = 2;
                    filterItems.recvState = 0;
                }
            }
            //
            filterItems.contractId = contractId;
            filterItems.cgVoucherId = this.cgVoucherId;
            filterItems.isContract = false;
            postData.filterItems = filterItems;
            postData.sortItemList = sortItemList;
            postData.sortItems = sortItems;
            //
            let msgBoxDlg = MsgBox.loading();
            goodsOrderApi.getGoodsOrderList(postData, function (result) {
                msgBoxDlg.close();
                if(result.type == 'info') {
                    let offlinePayWay = self.offlinePayWay;
                    let unionpayPayWay = self.unionpayPayWay;
                    let goodsOrderList = result.data.rows;
                    let pagination = result.data.pagination;
                    if(goodsOrderList != null && goodsOrderList.length > 0) {
                        for(let i = 0; i < goodsOrderList.length; i++) {
                            let goodsOrder = goodsOrderList[i];
                            self.tradeNo = goodsOrder.tradeNo;
                            self.cgVoucherNo = goodsOrder.cgVoucherNo;
                            self.tradeType = goodsOrder.tradeType;
                            if(offlinePayWay.value == goodsOrder.payWay) {
                                goodsOrder.payWayName = offlinePayWay.text
                            } else {
                                goodsOrder.payWayName = unionpayPayWay.text
                            }
                        }
                    }
                    self.goodsOrderList = goodsOrderList;
                    self.totalCount = pagination.totalCount;
                    self.pageNumber = pagination.pageNumber;
                    self.pageSize = pagination.pageSize;

                    self.renderTable(goodsOrderList, pagination);
                } else {
                    MsgBox.warning(result.message);
                }
            });
        },
        toGoodsOrderInfo: function (id, manualAllocFlag) {
            let pushDate = {};
            pushDate.path = SwbShowGoodsOrder.path;
            let queryData = {};
            if(this.flag) {
                queryData = {goodsOrderId: id, manualAllocFlag: manualAllocFlag, contractClosed: this.contranct.closed};
            } else {
                queryData = {goodsOrderId: id, manualAllocFlag: manualAllocFlag};
            }
            if(id != null) {
                pushDate.query = queryData;
            }
            this.$getRouter().push(pushDate);
        },
        // 发起投诉
        complaintSave: function (orderId) {
            let subjectType = getEnumInfoWith('complaintSubjectType', 'name', 'GoodsOrder');
            //
            this.$getRouter().push({
                path: SwbComplaintSave.path,
                query: {
                    orderId: orderId,
                    subjectType: subjectType.value
                }
            })
        },
        // 预付功能
        doPayPre(row) {
            let self = this;
            let params = {
                title: '订单金额 - 预付',
                doPrePay: true,
                showBtn: true,
                payPreFilter: {
                    orderType: getEnumInfoWith('orderType', 'name', 'GoodsOrder').value,
                    orderId: row.id,
                    orderNo: row.no,
                    sellerRealComId: row.sellerRealComId,
                    buyerRealComId: row.buyerRealComId,
                    amount: row.amount
                },
                filter: {
                    orderType: getEnumInfoWith('orderType', 'name', 'GoodsOrder').value,
                    orderId: row.id
                },
                parentSelf: self,
                parentPath: self.path
            };
            showPayVoucherListForSelectDlg(params, function (refresh) {
                //
                if(Utils.isTrue(refresh)) {
                    self.toGetGoodsOrderList();
                }
            });
        },
        resetpay: function (row) {
            let srcVoucherType = getEnumInfoWith("srcVoucherType", "name", "Order").value;
            let query = {srcVoucherType: srcVoucherType, srcVoucherId: row.id, srcVoucherInnerNo: row.no};
            showRouteLayer({
                title: '付款明细',
                query: query,
                template: SwbPayVoucherList
            });
        },
        doCancelGoodsOrderById: function (orderId) {
            let self = this;
            self.$prompt('请输入取消原因', '取消确认对话框', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
            }).then(function (data) {
                let cancelCause = data.value;
                //
                let postData = {};
                postData.orderId = orderId;
                postData.cancelCause = cancelCause;
                //
                let msgBoxDlg = MsgBox.loading();
                goodsOrderApi.doCancelGoodsOrder(postData, function (result) {
                    msgBoxDlg.close();
                    if(result.type == 'info') {
                        MsgBox.info('操作成功');
                        self.toGetGoodsOrderList();
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            }).catch(function () {

            });
        },
        toTradeVoucherList: function (tradeNo, contractNo) {
            let generalVoucher = this.generalVoucherType.value;
            let data = {no: tradeNo, tradeVoucherType: generalVoucher};
            if(contractNo != null) {
                data = {no: tradeNo};
            }
            let hashUrl = Utils.makeUrl(SwbTradeVoucherList.path, data);
            openPageRouteUrl(null, '/bench/home', hashUrl);
        },
        toCgVoucherList: function (no) {
            this.$getRouter().push({
                path: SwbDeviceRequireVoucherManager.path,
                query: {
                    no: no,
                }
            })
        },
        // 下载
        downloadPdf: function (id) {
            openGoodsOrderInfoForPdf(id, function (data) {
                //
            });
        },
        // isSignConfirm：true - 签署确认，false - 签字确认
        doSignConfirmed: function (goodsOrder, showView, isSignConfirm) {
            let titlePrefix = isSignConfirm ? '签署确认' : '签字确认';
            let title = showView ? '-查看' : '-上传PDF';
            let self = this;
            let theDlg = Vue.$showDialog({
                title: titlePrefix + title,
                showCloseBtn: true,
                okVisible: !showView,
                width: 700,
                height: 450,
                template: '<swb-goods-order-sign-confirmed-info :orderId="orderId" :showView="showView" ref="swb_sign_confirmed_info"></swb-goods-order-sign-confirmed-info>',
                data: {
                    orderId: goodsOrder.id || null,
                    showView: showView
                },
                methods: {},
                okClicked: function () {
                    let result = this.$refs.swb_sign_confirmed_info.getDlgResult() || {};
                    if(result.type == 'info') {
                        theDlg.close();
                        let resultData = result.data || {};
                        //
                        let postData = {};
                        postData.id = goodsOrder.id;
                        postData.signFileUuid = resultData.fileUuid || null;
                        postData.signFileMd5 = resultData.fileMd5 || null;
                        postData.signFileRemark = resultData.desc || null;
                        postData.isSignConfirm = isSignConfirm;
                        //
                        let msgBoxDlg = MsgBox.loading();
                        goodsOrderApi.updateGoodsOrderForSignConfirmed(postData, function (result) {
                            msgBoxDlg.close();
                            if(result.type == 'info') {
                                MsgBox.info('操作成功');
                                self.toGetGoodsOrderList();
                            } else {
                                MsgBox.warning(result.message);
                            }
                        });
                    } else {
                        MsgBox.warning(result.message);
                    }
                    return false;
                }
            });
        },
        // 跳转验收单
        toViewPurchReceipt: function (goodsOrder) {
            let path = SwbPurchReceiptList.path;
            this.$getRouter().push({
                path: path,
                query: {
                    trunsFlag: true,
                    contractFlag: false,
                    orderNo: goodsOrder.no
                }
            })
        },
        doShipAborted(row) {
            let self = this;
            this.$confirm('确定无需继续发货吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {
                let msgBoxDlg = MsgBox.loading();
                goodsOrderApi.doGoodsOrderShipAborted(row.id, function (result) {
                    msgBoxDlg.close();
                    if(result.type == 'info') {
                        MsgBox.info('操作成功');
                        self.toGetGoodsOrderList();
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            }).catch(function () {

            });
        },
        fileComn: function (row) {
            let self = this;
            let theDlg = Vue.$showDialog({
                title: '附件管理',
                width: 1100,
                height: 850,
                okVisible: false,
                cancelText: '关闭',
                template: '<div class = "">' +
                    '<swb-goods-order-img-list :id="id" ref="swb_servc_voucher_img_edit"></swb-goods-order-img-list>' +
                    '</div>',
                data: {
                    id: row.id
                }
            });
        },

        onlineSignForm: function (onlineSignFormId) {
            let self = this;
            let allowUpFlow = this.checkActionPerm('online_sign_form_up');
            let msgBoxDlg = MsgBox.loading();
            esignBizFormApi.getEsignBizFormById({id: onlineSignFormId}, function (esignResult) {
                msgBoxDlg.close()
                if(esignResult.type == 'info') {

                    openOnlineSignForm(esignResult.data, allowUpFlow, function (result) {
                        self.fetchData()
                        if(result) {
                            self.onlineSignForm(result)
                        }
                    })

                } else {
                    MsgBox.warning(esignResult.message)
                }
            })
        },
        showOnlineSignForm: function (onlineSignFormId) {
            //
            openOnlineSignFormView(onlineSignFormId);
        },
        setOrigFile: function (id) {
            openGoodsOrderInfoForPdf(id, function (data) {
                //
            });
        },
    }
}
</script>






// WEBPACK FOOTER //
// src/compo/order/GoodsOrderList.vue